// Wrapper face-api.js. Modelos servidos em /models (apps/web/public/models).
import * as faceapi from '@vladmandic/face-api';

const MODELS_URL = '/models';
let loaded = false;
let loading: Promise<void> | null = null;

export async function loadModels(): Promise<void> {
  if (loaded) return;
  if (loading) return loading;
  loading = (async () => {
    await faceapi.nets.tinyFaceDetector.loadFromUri(MODELS_URL);
    await faceapi.nets.faceLandmark68Net.loadFromUri(MODELS_URL);
    await faceapi.nets.faceRecognitionNet.loadFromUri(MODELS_URL);
    loaded = true;
  })();
  return loading;
}

export function isLoaded(): boolean {
  return loaded;
}

const detectorOptions = new faceapi.TinyFaceDetectorOptions({
  inputSize: 320,
  scoreThreshold: 0.5,
});

export async function captureEmbedding(videoEl: HTMLVideoElement): Promise<number[] | null> {
  if (!loaded) await loadModels();
  const result = await faceapi
    .detectSingleFace(videoEl, detectorOptions)
    .withFaceLandmarks()
    .withFaceDescriptor();
  if (!result || !result.descriptor) return null;
  return Array.from(result.descriptor);
}
